"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidSessionId = void 0;
const utils_1 = require("@hc-frontend/utils");
/**
 * Returns true if the string is a valid session id
 *
 * @public
 * @param {unknown} arg - A generic argument to check
 *
 * @returns {boolean}
 *
 * @example
 * ```ts
 * const result = isValidSessionId('21321');
 * console.log(result);
 * // -> true
 * ```
 **/
function isValidSessionId(arg) {
    return (0, utils_1.isString)(arg);
}
exports.isValidSessionId = isValidSessionId;
//# sourceMappingURL=is-valid-session-id.js.map